import { EStatusMatches } from '@/app/pages/sports/football/enums';
import { SportsService } from '@/app/services/sport.service';
import { TranslationService } from '@/app/services/translation.service';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  computed,
  effect,
  inject,
  input,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { MatchSummaryService } from '../../services';
import { ESportsApiV1 } from '@/app/models/sports.model';

@Component({
  selector: 'app-livetracker',
  standalone: true,
  imports: [],
  templateUrl: './livetracker.component.html',
  styleUrl: './livetracker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LivetrackerComponent {
  // Inyecciones
  matchSummaryService = inject(MatchSummaryService);

  private sanitizer = inject(DomSanitizer);
  private sportsService = inject(SportsService);
  private translatorService = inject(TranslationService);

  // Inputs y señales
  matchIdProp = input.required<string>();
  protected profile = '8nq2ghpoouzulmy';
  protected version = '3D';
  protected urlWidget = environment.urlWidgets;

  @ViewChild('mainTracker') mainTracker!: ElementRef;

  // Estado interno
  isTrackerHidden = false;
  viewLiveTracker = false;

  // Computed: sportId
  private sportTracker = computed(() => {
    return this.sportsService.searchSport(ESportsApiV1.FOOTBALL).tracker;
  });

  // Computed: URL
  protected linkLiveTracker = computed<SafeResourceUrl>(() => {
    const lang = this.translatorService.getCurrentLanguage();
    const sport = this.sportTracker();
    const uuid = this.matchIdProp();

    const url = `${this.urlWidget}${lang}/${this.version}/${sport}?profile=${this.profile}&uuid=${uuid}`;

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  });

  onlyViewTrackerByStatusMatch = computed(() => {
    return (
      this.matchSummaryService.matchSummary()?.State === EStatusMatches.NORMAL
    );
  });

  constructor() {
    effect(() => {
      const id = this.matchIdProp();
      const noProd =
        environment.envName === 'local' || environment.envName === 'dev';
      if (id && noProd) {
        console.log('Match ID recibido:', id);
        // this.viewLiveTracker = true;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.mainTracker) {
      const trackerPosition =
        this.mainTracker.nativeElement.getBoundingClientRect();
      this.isTrackerHidden =
        trackerPosition.bottom < 0 || trackerPosition.top > window.innerHeight;
      this.viewLiveTracker = true;
    }
  }
}
